function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.4;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{opacity:0.21;mix-blend-mode:multiply;fill:url(#Degradado_sin_nombre_94);}.cls-16{fill:url(#linear-gradient-13);}.cls-17{fill:#fff;}.cls-18{fill:url(#Degradado_sin_nombre_126);}.cls-19{fill:url(#Degradado_sin_nombre_126-2);}.cls-20{fill:url(#Degradado_sin_nombre_126-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 172.54,
  y1: 155.93,
  x2: 157.19,
  y2: 215.33,
  gradientTransform: "matrix(0.99, -0.1, 0.1, 0.99, -9.04, -42.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00d9ef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005eef"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 104.66,
  y1: 139.83,
  x2: 86.51,
  y2: 210.02,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 184.76,
  y1: 154.6,
  x2: 167.37,
  y2: 221.86,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 159.2,
  y1: 151.01,
  x2: 139.61,
  y2: 226.79,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 129.71,
  y1: 145.73,
  x2: 110.71,
  y2: 219.23,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 148.73,
  y1: 150.24,
  x2: 131.92,
  y2: 215.25,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 194.07,
  y1: 159.46,
  x2: 179.42,
  y2: 216.11,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 118.39,
  y1: 144.09,
  x2: 102.48,
  y2: 205.63,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 145.93,
  y1: 148.58,
  x2: 135.01,
  y2: 190.8,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 171.42,
  y1: 153.78,
  x2: 160.86,
  y2: 194.63,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 111.89,
  y1: 143.52,
  x2: 99.71,
  y2: 190.65,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 164.22,
  y1: 87.75,
  x2: 149.27,
  y2: 170.35,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_94",
  x1: 126.55,
  y1: 152.62,
  x2: 151.19,
  y2: 60.04,
  gradientTransform: "matrix(0.99, -0.1, 0.1, 0.99, -9.04, -42.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f4a4f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#b78aed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#855fed"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 186.48,
  y1: 91.93,
  x2: 186.48,
  y2: 193.34,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_126",
  cx: 210.29,
  cy: 6.57,
  r: 6.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#fff",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#fff",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#fff",
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#fff",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#fff",
  stopOpacity: 0.34
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#fff",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#fff",
  stopOpacity: 0.62
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#fff",
  stopOpacity: 0.79
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#fff",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_126-2",
  cx: 58.52,
  cy: 59.09,
  r: 10.27,
  xlinkHref: "#Degradado_sin_nombre_126"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Degradado_sin_nombre_126-3",
  cx: 250.39,
  cy: 90.73,
  r: 10.27,
  xlinkHref: "#Degradado_sin_nombre_126"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M170.82,94.44c3.92,5.4,7.86,11.85,6.68,18.83-.85,5-3.77,9.49-5.17,14.38-2.74,9.59-.26,20,2.82,29.21.29.87,1.81.54,1.61-.39-1.28-6-3-11.87-3.19-18-.25-7,2-12.48,4.52-18.82,3.92-10,.53-18.12-6-26.13a.81.81,0,0,0-1.31,1Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M119.06,86.14c-16.49,2.15-9.57,26.42-11.76,37.17-1.65,8.08-11.2,9.85-15.57,16.18a20.13,20.13,0,0,0-3,17.13c.46,1.55,2.79.86,2.69-.65-.48-6.86,1.23-13.66,6.92-18,4.22-3.23,9.34-4.85,11.76-10,2.14-4.51,1.7-9.64,1.49-14.48-.28-6.71-1.14-22.75,7.75-24.82,1.55-.36,1.42-2.77-.26-2.55Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M179.76,91.82c3.94,6.1,8.51,12.77,9.24,20.19.68,6.82-3.12,12.89-5,19.19-3.08,10.1-2,23.43,4.86,31.88a1.07,1.07,0,0,0,1.86-1c-2.57-7.09-4.87-13.5-4.22-21.23.58-7,3.67-13,5.63-19.55,3.58-12.06-2.67-22.06-10.08-31.1a1.39,1.39,0,0,0-2.25,1.64Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M162.85,90.48c-11,10.61-3.57,26.75-2.94,39.59.41,8.29-3.12,15.05-6.23,22.47-2.19,5.21-4.27,11-2.71,16.63a1.46,1.46,0,0,0,2.79-.29,54.16,54.16,0,0,1,5-18.31c2.38-5.31,4.68-10.62,5-16.51.79-13.94-8.08-29.16,1.21-41.85a1.37,1.37,0,0,0-2.12-1.73Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M145.68,89.84c-5.62-2.2-11.45.65-14.46,5.72-4.34,7.33-1.94,17.14-1,25,1.19,10,4.07,23.3-5.38,30.32-4.91,3.65-11.9,4.6-13.32,11.4a1.12,1.12,0,0,0,1.95.89c3.67-5.16,9.92-6.28,14.61-10.1s6.75-9.63,7.19-15.42c.7-9.25-10.07-49.89,9.65-45.31a1.33,1.33,0,0,0,.77-2.52Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M153.18,91c-10.5,7.11-4.45,20.53-3.27,30.43,1,8.33-2.92,15-4.58,22.87-1.09,5.19-.89,10.64,2.87,14.69a.61.61,0,0,0,1-.72C142.65,147,152.12,136.48,152,125c-.09-10.6-7.43-23.94,2.13-32.61a.82.82,0,0,0-1-1.32Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M197,95.44c-8.43,9.81,4.55,21.39,1.2,32-2.76,8.77-13.87,17.21-7.63,27.09.55.87,2.07.07,1.6-.87-5.2-10.33,6.62-17.82,8.56-27.24,2.08-10.11-9.19-20.57-2.49-30a.8.8,0,0,0-1.24-1Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M123.32,89.35c8.31,12.37-9.32,16.26-10.09,27-.4,5.47,3.06,10.29,3.81,15.58,1,7.13-2.47,13.53-7.71,18.05a1,1,0,0,0,1.19,1.63,20.94,20.94,0,0,0,8.58-12.9c1.47-6.66-1.27-11.66-2.83-18-2.38-9.57,6.65-11.84,10.24-18.9a12.32,12.32,0,0,0-1.74-13.55.9.9,0,0,0-1.45,1.06Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M155.77,91.69c.88,1,0,4.16-.45,5.35a15.39,15.39,0,0,1-2.83,4.11,36.69,36.69,0,0,1-6.25,5.22c-2.84,2-5.24,4.12-6.36,7.54-2.45,7.49,1.89,15.66,7.35,20.62.82.75,1.93-.42,1.36-1.29-3-4.65-6.73-8.94-6.72-14.79,0-7.09,5.49-9.33,10-13.54,3.09-2.89,9.28-10.21,5-14.29-.64-.61-1.71.39-1.13,1.07Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M173.61,91.9a17.35,17.35,0,0,0-5.63,17c.76,3.49,2.57,6,4.88,8.66,4.62,5.34,4.53,11.29,3.58,17.94a.8.8,0,0,0,1.57.27c2.12-7.12,1.47-13.81-3.41-19.48-6-7-6.81-16.24.06-23.24.61-.62-.39-1.68-1-1.11Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M127.51,90.62c1.06,7-6,10.2-11,13A63.32,63.32,0,0,0,104.25,112c-7,6.42-7.38,14.48-5.5,23.32.21,1,1.66.87,1.56-.16-.59-6.28-1.58-12.68,2.18-18.21,3.36-4.93,9.08-8.47,14.2-11.38,6-3.39,14.22-6.79,12.55-15.15-.22-1.08-1.9-1-1.73.17Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M205.89,89.57a10,10,0,0,1-10.42,6.68L150.39,91.9l-30.93-3a9.93,9.93,0,0,1-8.95-8.57c-3.33-28.08,24.87-61.4,58.77-53.62A51.84,51.84,0,0,1,183,32.08C214.65,49.72,210.33,76.66,205.89,89.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M138.13,68.7c1.73,7.32,5.67,14.06,10.12,20.06.38.51,1.18,1.77,2.14,3.14l-30.93-3a9.93,9.93,0,0,1-8.95-8.57c-3.33-28.08,24.87-61.4,58.77-53.62-2.7,1.12-5.21,2.41-6.58,3.08C147.89,37.16,133.91,50.89,138.13,68.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M177.5,34.68c14.73.88,28.17,20.89,27.92,34.67C205,91.55,188.49,99,183.72,78.2s-1.87-18.42-10.18-30.43c-3-4.29-4.52-12.6,3-13.08C176.87,34.67,177.18,34.67,177.5,34.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M27.6,124c0,1.64,0,2.77-.15,5.38-.36,6.21-4.42,10.67-13.6,10.67-9.59,0-13.54-5-13.8-12.72l0-1.54H9.23l.11,1.54c.3,4.62,2.15,6,4.77,6s3.9-1.64,4.15-4.46c.11-1.18.11-2.31.11-3.39V103.94H27.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M59.71,128H40.63c.46,4.56,2.46,5.85,5.07,5.85s4.21-1.34,4.57-3.44h9.08c-1.59,6.2-6.72,9.69-13.75,9.69-7.85,0-14.1-4.67-14.1-14.31,0-8,5.48-14.52,14.62-14.52s13.74,7,13.74,14.06A25.44,25.44,0,0,1,59.71,128ZM40.93,122.3h9.29c-.51-3.23-2.1-4.82-4.57-4.82S41.55,118.92,40.93,122.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M72.89,129.49A16.41,16.41,0,0,0,73,132c.16,1.08.62,1.43,3,1.33v6.26c-1.69.15-3.33.26-5.39.26-4.25,0-6.66-1.7-6.87-5.34-.1-1.43-.1-2.82-.1-4.87v-28h9.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M88.54,129.49a16.41,16.41,0,0,0,.1,2.51c.15,1.08.61,1.43,3,1.33v6.26c-1.7.15-3.34.26-5.39.26-4.26,0-6.67-1.7-6.88-5.34-.1-1.43-.1-2.82-.1-4.87v-28h9.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M113.16,139.33c-3.44,8.67-6.41,10.78-12.93,10.78a23.22,23.22,0,0,1-3.9-.26V143.9a19.93,19.93,0,0,0,2.52.1c2.15,0,3.64-.72,4.51-2.66l.36-.77L92.38,111.94h10.26L108.29,132l5.59-20.06H124Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M156.59,114h-9.23c-.41-2.93-2-4.88-5-4.88-2.1,0-3.54,1-3.54,3.18s1.64,3.65,7.49,5c7.8,1.85,11,5.75,11,11.18,0,7.08-6.77,10.68-13.9,10.68-9,0-15-3.6-15.6-11.55h9.24c.61,3.34,3.33,4.77,6.1,4.77,2.56,0,4.51-1.33,4.51-3.28s-1.33-3.44-5.69-4.51c-8.05-2-12.77-4.52-12.77-11.6,0-6.82,6.36-10.67,13.39-10.67C151.92,102.32,155.82,107.4,156.59,114Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M183.21,139.33c-3.44,8.67-6.41,10.78-12.93,10.78a23.22,23.22,0,0,1-3.9-.26V143.9a20,20,0,0,0,2.52.1c2.15,0,3.64-.72,4.51-2.66l.36-.77-11.33-28.63H172.7L178.34,132l5.59-20.06H194Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M224.2,123.84v15.49H215v-14c0-.87,0-2.36-.1-3.74-.2-2.62-1.64-4.16-4.41-4.16s-4.82,2.72-4.82,8.93v12.92h-9.24V111.94h9.24v4.26l2.46-3.39a11.46,11.46,0,0,1,6.15-1.59c5.65,0,9,2.67,9.7,7.44A36.85,36.85,0,0,1,224.2,123.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M255.54,122.41h-8.93c-.41-3.6-2.2-4.93-4.51-4.93-3.08,0-4.77,2.62-4.77,7.9,0,5.85,1.74,8.42,4.87,8.42,2.1,0,3.85-1.54,4.36-4.52h9.08c-1,7.08-6.51,10.77-13.95,10.77-7.85,0-13.8-5.08-13.8-14.11,0-9.43,6.36-14.72,14.41-14.72S255.28,116.25,255.54,122.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M216.87,6.57A6.58,6.58,0,1,1,210.29,0,6.58,6.58,0,0,1,216.87,6.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M68.79,59.09A10.28,10.28,0,1,1,58.52,48.82,10.27,10.27,0,0,1,68.79,59.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M260.66,90.73a10.27,10.27,0,1,1-10.27-10.27A10.27,10.27,0,0,1,260.66,90.73Z"
}))));

var SvgLogoWithText = function SvgLogoWithText(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 260.66 170.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoWithText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LogoWithText.56f27da4.svg";
export { ForwardRef as ReactComponent };